import React,{Component,Fragment} from 'react';
import {AppBar,Toolbar,Typography,IconButton,Badge,Grid} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import LogoutIcon from '@material-ui/icons/ExitToApp'
import NotificationsIcon from '@material-ui/icons/Notifications';
import {BLUE_COLOR, LIGHTGRAY_COLOR, MODIFIEDBLACK} from "../constants";
export default class HRAppbar extends Component{

    handleMenuButton(){
        const callback = this.props.onMenuClick;
        if(callback){
            setTimeout(callback,20,"");
        }
    }
    render() {
        return(
                <AppBar position="static" style={{backgroundColor:'white',paddingTop:10}}>
                    <Toolbar>
                        <IconButton onClick={()=>this.handleMenuButton()}
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                        >
                            <MenuIcon />
                        </IconButton>

                        <div style={{position:'absolute',right:20,display:'flex'}}>

                            <div style={{width:250,display:'flex'}}>
                                <div style={{backgroundColor:BLUE_COLOR,borderRadius:60,height:40,width:40,justifyContent:'center'}}>
                                    <Typography style={{color:'white',fontFamily:'Globerbold',fontSize:18,textAlign:'center',paddingTop:6}}>S</Typography>
                                </div>
                                <div style={{display:'column',marginLeft:10}}>
                                    <Typography style={{color:MODIFIEDBLACK,fontFamily:'Globerbold',marginTop:-2}}>Swan</Typography>
                                    <Typography style={{color:MODIFIEDBLACK,fontFamily:'Globerregular',marginTop:-5}}>Swan User</Typography>
                                </div>
                            </div>

                            <IconButton aria-label="show 17 new notifications" color="inherit">
                                <Badge badgeContent={17} color="error" >
                                    <NotificationsIcon style={{color:MODIFIEDBLACK}}/>
                                </Badge>
                            </IconButton>

                            <div style={{height:35,width:1,backgroundColor:'rgba(191,193,194,1.0)',marginLeft:10,marginRight:10,marginTop:5}}/>

                            <IconButton color="inherit">
                                <LogoutIcon style={{color:BLUE_COLOR,marginTop:-5}} fontSize={'large'}/>
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>

        )
    }
}